import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain";
import DocumentsListView from "../../components/modules/documentsListView/DocumentsListView";

export default function ViewDocumentDetail() {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <div>
        <DocumentsListView />
      </div>
    </AppWrapper.WithSidebar>
  );
}
